import styled from 'styled-components'
import { HEADER_DEFAULT_Y } from '@/features/shared/constants/global'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { Row } from '@shipt/design-system-layouts'

export const MainHeaderWrapper = styled(GridLayoutContainer)`
  height: ${HEADER_DEFAULT_Y}px;
`

export const CategorySubNavContainer = styled(GridLayoutContainer)<{
  $holidayGHP?: boolean
}>`
  height: 3rem;
  background-color: ${({ theme, $holidayGHP }) =>
    $holidayGHP
      ? theme.color.background.base.brand.primary
      : theme.color.background.base.neutral.subtle_00};
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-color: ${({ theme }) => theme.color.border.base.neutral.subtle};
`

export const AutocompletePill = styled(Row)`
  align-items: center;
  width: 100%;
  border-radius: 999px;
  padding: 4px;
  height: 3rem;
  background-color: ${({ theme }) => theme.color.background.base.neutral.subtle_100};

  &:focus-within {
    border: 2px solid ${({ theme }) => theme.color.border.action.primary_heavy};
    padding: 2px;
  }
`
